import request from "@/utils/request";

export function searchBankList(params) {
  return request({
    url: `/common/bank/searchBank`,
    params,
  });
}

export function searchBankBranchList(params) {
  return request({
    url: `/common/bank/searchBankBranch`,
    params,
  });
}
